// ── MowRate Design Tokens — Light Theme ──────────────────────
export const C = {
  // Backgrounds
  bg0: "#FAFAFA",        // Main page background (clean white)
  bg1: "#F5F2EF",        // Card surface (warm gray)
  bg2: "#EDEBE8",        // Elevated surface, inputs
  bg3: "#E5E2DF",        // Hover states

  // Borders
  border: "#E5E5E5",     // Default borders
  borderHi: "#D1D1D1",   // Active/focus borders

  // Primary accent
  gold: "#E8553D",       // Deep coral — primary CTAs, accents, wordmark "Rate"
  goldDim: "#C44530",    // Pressed/shadow states
  goldGlow: "#E8553D12", // Subtle card backgrounds
  goldLight: "#F0877A",  // Active text on coral elements

  // Text
  white: "#1C1C28",      // Primary text (dark slate)
  offwhite: "#2D2D3A",   // Secondary text
  muted: "#6B7280",      // Tertiary text (cool gray)
  ghost: "#9CA3AF",      // Quaternary — disabled, hints, labels

  // Semantic
  teal: "#2BA58E",       // Success / profit (teal green)
  tealDim: "#1E8A74",    // Teal pressed
  danger: "#D93025",     // Danger / loss / errors

  // PDF colors (keep for dark-bg PDFs)
  paper: "#FEFDF8",
  paperLine: "#E4E0D0",
  paperText: "#18140A",
  paperSub: "#6A6050",
  paperGold: "#E8553D",
  paperNavy: "#1C1C28",
};
